import { Card } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { GuarantorsDE } from '../GuarantorsDE/GuarantorsDE';
import { PersonalDetailsDE } from '../PersonalDetailsDE/PersonalDetailsDE';
import signupFormStyles from '../SignupForm/SignupForm.module.css';

export const PersonalInformationDE = () => {
  return (
    <Card className={signupFormStyles.formSection}>
      <h2>
        <Trans>Applicant details</Trans>
      </h2>
      <PersonalDetailsDE roleType="applicant" />
      <GuarantorsDE />
    </Card>
  );
};
